import { UserState } from "@State/app.state";
import { createReducer, on } from "@ngrx/store";
import * as UserActions from "@Actions/user.actions"

const userInitialState: UserState = {
  anagraficaUtente: {
    codanaute: -1,
    nom: "",
    cog: "",
    datnas: null,
    ses: null,
    codfis: null,
    idetippfe: null,
    codcmnnas: null,
    descmnnas: null,
    idenaznas: null,
    desnaznas: null,
    eml: "",
    tel: null,
    telmob: null,
    codtipdcm: null,
    numdcm: null,
    datscndoc: "",
    indutetut: false,
    ideclaute: null,
    prgpmpclaute: null,
    addresses: [],
    indaut: -1,
    indautpub: -1,
    indautctgprc: -1,
    idenazcit: null,
    desnazcit: null,
  },
  infoUtenteLoggato: {
    token: "",
    version: "",
    account: {
      ideaot: -1,
      idestoaot: -1,
      usr: "",
      censito: false,
    }
  },
  loadError:null,
  infoLoaded:false
}

export const userReducer = createReducer(
  userInitialState,
  on(UserActions.setAnagraficaUtente, (state, { anagraficaUtente }) => ({
    ...state,
    anagraficaUtente
  })),
  on(UserActions.setLoggedUserInfo, (state, { infoUtenteLoggato }) => ({
    ...state,
    infoUtenteLoggato
  })),
  on(UserActions.setAllUserInfo, (state, { anagraficaUtente, infoUtenteLoggato }) => {
    return { ...state, anagraficaUtente:anagraficaUtente, infoUtenteLoggato:infoUtenteLoggato };
  }),
  on(UserActions.clearUserInfo, () => {
    return userInitialState;
  }),
  on(UserActions.userStateError, (state, { loadError }) => ({...state, loadError})),
  on(UserActions.userInfoLoaded, (state, { infoLoaded }) => ({...state, infoLoaded}))
)
